<template>
    <section class="screen-wrapper"
        @touchmove.prevent="() => {}">
        <div class="screen-wrapper-box"
            :style="{ top: `${ top }px` }"
            :class="{ 'vertical-center': !top }">
            <slot />
            <div class="screen-wrapper-close"
                v-if="showClose"
                @click="handleClose"></div>
        </div>
    </section>
</template>

<script>
    /** eslint-disable */
    export default {
        name: 'ScreenWrapper',
        props: {
            /**
             * 是否需要关闭按钮
             */
            showClose: {
                type: Boolean,
                default: true
            },
            /**
             * slot内容top定位值，默认居中
             * 单位: px
             */
            top: {
                type: Number
            }
        },
        methods: {
            handleClose() {
                this.$emit('close')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../style/main';

    .screen-wrapper {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 3;
        background-color: rgba(#000, .6);

        &-box {
            transform: translateX(-50%);
            position: absolute;
            left: 50%;

            &.vertical-center {
                transform: translate(-50%, -50%);
                top: 50%;
            }
        }

        &-close {
            $size: rem(80);
            margin: rem(60) auto 0;
            width: $size;
            height: $size;
            background: {
                image: url('../assets/images/live-icon-close.png');
                size: contain;
            }
        }
    }
</style>
